import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import AtmPayRollUpdate from "./AtmPayRollUpdate/AtmPayRollUpdate";
import AtmPayRollDetailsUpdate from "./AtmPayRollDetailsUpdate/AtmPayRollDetailsUpdate";
import PhysicalCardDetailsUpdate from "./PhysicalCardDetailsUpdate/PhysicalCardDetailsUpdate";
import { useLocation } from "react-router-dom";

export default function AtmPayroll() {
  const location = useLocation();

  //screen Title Show fun
  const dispatch = useDispatch();
  const titleBorder = [{ label: "ATM Payroll", link: "/dashboard/AtmPayroll" }];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    if (location.state == null) {
    } else {
      setIndex(1);
    }
  }, []);

  const [index, setIndex] = useState(0);

  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="flex items-center justify-between">
          <div className="flex">
            <button
              className={`p-2 m-2  text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
              onClick={() => handleIndex(0)}
            >
              ATM & PAYROLL CATEGORY UPDATE LIST
            </button>
            <button
              onClick={() => handleIndex(1)}
              className={`p-2 m-2  text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
            >
              ATM & PAYROLL DETAILS UPDATE
            </button>
            <button
              onClick={() => handleIndex(2)}
              className={`p-2 m-2  text-black uppercase text-xs mr-4 rounded-md  ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
            >
              PHYSICAL CARD DETAILS UPDATE
            </button>
          </div>
          {/* {index == 1 ? (
            <div className="flex items-center justify-center">
              <div className=" w-5 p-2 m-2 h-5 bg-warning" />
              <p>Missing Details</p>
              <div className=" w-5 p-2 m-2 h-5 bg-error" />
              <p>Delayed</p>
            </div>
          ) : (
            <></>
          )} */}
        </div>
        {index === 0 ? (
          <AtmPayRollUpdate />
        ) : index === 1 ? (
          <AtmPayRollDetailsUpdate setIndex={setIndex} />
        ) : index === 2 ? (
          <PhysicalCardDetailsUpdate />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
